import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const WrapperLink = ({ to, ...props }) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 150)

    return () => clearTimeout(timer)
  }, [])

  return <Link to={to} rel="noopener noreferrer" {...props} style={{ visibility: mounted ? 'visible' : 'hidden' }} />
}

export default WrapperLink
